import React, { useState, useEffect } from "react";
import { Box, Button, Typography, Paper } from "@mui/material";
import { useSelector, useDispatch } from 'react-redux';
import { setDisplayedPhoto, selectDisplayedPhoto } from '../app/interface.js';
import ZoomableSVG from "./ZoomableSVG.jsx";

const PhotoPopupDisplayer = () => {
  const dispatch = useDispatch();
  const [position, setPosition] = useState({ x: 200, y: 70 });
  const [isDragging, setIsDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const displayedPhoto = useSelector(selectDisplayedPhoto);

  // Popup window event handling:
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setOffset({ x: e.clientX - position.x, y: e.clientY - position.y });
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      const topbar_height = document.getElementById("topbar").clientHeight;
      setPosition({
        x: e.clientX - offset.x,
        y: (e.clientY - offset.y >= topbar_height) ? e.clientY - offset.y : topbar_height,
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    if (isDragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    } else {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    }

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging]);

  // ESC
  const handleEscape = (event) => {
    if (event.key === "Escape") {
      dispatch(setDisplayedPhoto(null));
    }
  };

  // Add event listener for Esc key
  useEffect(() => {
    if (displayedPhoto == null){
      window.removeEventListener("keydown", handleEscape);
    }
    else{
      window.addEventListener("keydown", handleEscape);
    }
  }, [displayedPhoto]);

  // For the moment, let's define the popup size in pixels:
  const popup_maxwidth = 700;
  const popup_maxheight = 500;

  // No photo selected:
  if (displayedPhoto == null){
    return (<div></div>);
  }
  // A photo selected
  else {
    const coords = displayedPhoto?.geometry?.coordinates;
    const coordX = Array.isArray(coords) ? coords[0] : '?';
    const coordY = Array.isArray(coords) ? coords[1] : '?';

    return (
      <Paper
        elevation={3}
        style={{
          position: 'absolute',
          top: position.y,
          left: position.x,
          width: `${popup_maxwidth}px`,
          zIndex: 'var(--z-popup)',
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          style={{ cursor: 'grab', background: '#2154A5', color: 'white', padding: '0 10px' }}
          onMouseDown={handleMouseDown}
        >
          <Typography variant="h6" style={{ flexGrow: 1 }}>
            Photo position: [{coordX}, {coordY}]
          </Typography>
          <Button onClick={() => dispatch(setDisplayedPhoto(null))} style={{ color: 'white', padding: 0, minWidth: 0}}>
            X
          </Button>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="stretch"
          padding={2}
          style={{ width: `${popup_maxwidth - 32}px` }}
        >
          <Box style={{ height: `${popup_maxheight - 32}px`, flexShrink: 0 }}>
            <ZoomableSVG
              imageUrl={displayedPhoto.url}
              width={popup_maxwidth - 32}
              height={popup_maxheight - 32}
            />
          </Box>
        </Box>
      </Paper>
    );
  }
};

export default PhotoPopupDisplayer;
